module.exports = __webpack_public_path__ + "static/media/forma-naranja.0be38124.svg";